import OffersAdd from "../../main/modules/Offers/pages/OffersAdd";
import OffersEdit from "../../main/modules/Offers/pages/OffersEdit";
import OffersList from "../../main/modules/Offers/pages/OffersList";

const offerLayoutRoutes = [
    {
        path: "",
        name: "OffersList",
        component: OffersList,
        meta: {
            isAuth: true,
            module: "offers",
            subModule: ""
        }
    },
    {
        path: "add",
        name: "OffersAdd",
        component: OffersAdd,
        meta: {
            isAuth: true,
            module: "offers",
            subModule: ""
        },
    },
    {
        path: "edit",
        name: "OffersEdit",
        component: OffersEdit,
        meta: {
            isAuth: true,
            module: "offers",
            subModule: ""
        }
    }
]

export default offerLayoutRoutes;